import type { Node } from 'prosemirror-model';

import { getHeadingIdForNode } from './headingLinksFromElements.ts';

export const copyLink = async (
	node: Node,
	getHeadingLinkPath: () => string | null,
): Promise<boolean> => {
	try {
		const headingId = getHeadingIdForNode(node);
		if (!headingId) {
			return false;
		}

		const path = getHeadingLinkPath();

		if (!path) {
			return false;
		}

		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		const url = new URL(location.origin + path);

		url.hash = encodeURIComponent(headingId);
		const href = url.toString();

		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
			// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
			await navigator.clipboard.writeText(href);
			return true;
		}

		return false;
	} catch {
		return false;
	}
};
